import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EditItem from './EditItem';

import editProductForItem from '../../../../../../actions/editProductForItem';

const mapDispatchToProps = dispatch => bindActionCreators({
  editProductForItem,
}, dispatch);

export default connect(undefined, mapDispatchToProps)(EditItem);
